"use client";

import { useEffect } from "react";

export default function ExternalLinksHandler() {
  useEffect(() => {
    const handleExternalLinks = () => {
      const strapiContent = document.querySelectorAll(".strapi-content");
      strapiContent.forEach((content) => {
        const links = content.querySelectorAll("a[href]");
        links.forEach((link) => {
          const href = link.getAttribute("href");
          if (
            href &&
            href.startsWith("http") &&
            !href.includes("moneyline.com")
          ) {
            link.setAttribute("target", "_blank");
            link.setAttribute("rel", "noopener noreferrer");
          }
        });
      });
    };

    // Run immediately
    handleExternalLinks();

    // Also run when content might be dynamically updated
    const observer = new MutationObserver(handleExternalLinks);
    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    return () => observer.disconnect();
  }, []);

  return null;
}
